import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [phoneChecked, setPhoneChecked] = useState(false);
  const [needsPhone, setNeedsPhone] = useState(false);

  useEffect(() => {
    const checkPhoneRequirement = async () => {
      const requirePhone = sessionStorage.getItem('requirePhoneCompletion');
      
      if (requirePhone === 'true' && user && location.pathname !== '/perfil') {
        const { data } = await supabase
          .from('profiles')
          .select('phone')
          .eq('id', user.id)
          .single();
        
        if (!data?.phone) {
          setNeedsPhone(true);
        } else {
          sessionStorage.removeItem('requirePhoneCompletion');
          setNeedsPhone(false);
        }
      } else {
        setNeedsPhone(false);
      }
      setPhoneChecked(true);
    };

    if (!loading && user) {
      checkPhoneRequirement();
    } else if (!loading) {
      setPhoneChecked(true);
    }
  }, [user, loading, location.pathname]);

  if (loading || (!phoneChecked && user)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (needsPhone && location.pathname !== '/perfil') {
    return <Navigate to="/perfil" replace />;
  }

  return <>{children}</>;
}
